import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=01077179&scoped=true"
import script from "./CommonButton.vue?vue&type=script&lang=js"
export * from "./CommonButton.vue?vue&type=script&lang=js"
import style0 from "./CommonButton.vue?vue&type=style&index=0&id=01077179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01077179",
  null
  
)

export default component.exports